import CompanyWorkingViewComponent from "../components/CompanyWorkingView";
import useCompanyWorking from "../hooks/useCompanyWorking";

const CompanyWorkingView = (props) => {
  const useCompanyWorkingProps = useCompanyWorking(props);
  return <CompanyWorkingViewComponent {...useCompanyWorkingProps} />;
};

export default CompanyWorkingView;
